import StepOne from './StepOne';
import StepTwo from './StepTwo';

const stepComponents = {
  1: StepOne,
  2: StepTwo,
};

export default stepComponents;
